import React from "react";
import {
  Box,
  Container,
  Typography,
  Link,
  TextField,
  Grid,
  IconButton,
} from "@mui/material";
import { PiPhoneCallThin } from "react-icons/pi";
import { CiLocationOn } from "react-icons/ci";
import { IoCallOutline } from "react-icons/io5";
import { IoMdTime } from "react-icons/io";
import { FiSend } from "react-icons/fi";
import flogo from "../assests/flogo.png";
import Calltoaction from "./Calltoaction";
import { FaFacebookSquare, FaLinkedin, FaTwitter } from "react-icons/fa";
const linkStyle = {
  display: "block",
  mb: 1,
  fontFamily: `"Lato", sans-serif`,
  fontWeight: 400,
  fontSize: "15px",
  lineHeight: { sx: "20px", md: "24px" },
  margin: "10px",
  color: "#253D4E",
  opacity: "0.6",
};
const socialLinks = [
  {
    icon: <FaLinkedin sx={{ fontSize: 30 }} />,
    url: "https://www.linkedin.com/",
    label: "LinkedIn",
  },
  {
    icon: <FaFacebookSquare sx={{ fontSize: 30 }} />,
    url: "https://www.facebook.com/",
    label: "Facebook",
  },
  {
    icon: <FaTwitter sx={{ fontSize: 30 }} />,
    url: "https://www.twitter.com/",
    label: "Twitter",
  },
];
const Acountlinks = [
  { label: "Login", href: "/login" },
  { label: "Signup", href: "/signup" },
];
const Pageslinks = [
  { label: "Vendors", href: "/vendor" },
  { label: "Contact us", href: "/contactus" },
  { label: "Privacy policy", href: "/privacy-policy" },
  { label: "Terms and conditions", href: "/terms-and-conditions" },
];
const AFooter = () => {
  return (
    <>
      <Calltoaction />
      <Box
        sx={{
          backgroundColor: "#fff",
          padding: "0px 0",
          mt: 4,
          width: "100%",
        }}
      >
        <Container maxWidth="xl">
          <Grid container sx={{ width: "100%" }} spacing={4}>
            {/* Logo Section */}
            <Grid item size={{ xs: 12, sm: 12, md: 3, lg: 3 }}>
              <Box
                sx={{ textAlign: { xs: "center", sm: "center", md: "left" } }}
              >
                <img
                  src={flogo}
                  alt="Footer Logo"
                  sx={{ marginBottom: "20px" }}
                />
                <Typography
                  sx={{
                    fontFamily: `"Lato", sans-serif`,
                    fontWeight: 400,
                    fontSize: "15px",
                    margin: "30px auto",
                    color: "#253D4E",
                    lineHeight: "24px",
                    textAlign: { sm: "center", md: "left" },
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  Provides patients with valuable health information and
                  promotes proactive health management.
                </Typography>
              </Box>
            </Grid>

            {/* Quick Links */}
            <Grid item size={{ xs: 12, sm: 12, md: 2, lg: 2 }}>
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  fontFamily: `"Quicksand", sans-serif`,
                  fontWeight: 700,
                  fontSize: "24px",
                  lineHeight: "28.8px",
                  margin: "10px 10px 20px",
                  color: "#253D4E",
                }}
              >
                Company
              </Typography>
              <Box>
                <Link href="/" underline="none" sx={linkStyle}>
                  Home
                </Link>
                <Link href="/aboutus" underline="none" sx={linkStyle}>
                  About Us
                </Link>
                <Link href="/shop" underline="none" sx={linkStyle}>
                  Shop
                </Link>
                <Link href="/cart" underline="none" sx={linkStyle}>
                  My cart
                </Link>
              </Box>
            </Grid>

            {/* Legal Links */}
            <Grid item size={{ xs: 12, sm: 12, md: 2, lg: 2 }}>
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  fontFamily: `"Quicksand", sans-serif`,
                  fontWeight: 700,
                  fontSize: "24px",
                  lineHeight: "28.8px",
                  margin: "10px 10px 20px",
                  color: "#253D4E",
                }}
              >
                Account
              </Typography>
              <Box>
                {Acountlinks.map((link) => (
                  <Link
                    key={link.label}
                    href={link.href}
                    underline="none"
                    sx={linkStyle}
                  >
                    {link.label}
                  </Link>
                ))}
              </Box>
            </Grid>

            {/* Vision & Mission Links */}
            <Grid item size={{ xs: 12, sm: 12, md: 2, lg: 2 }}>
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  fontFamily: `"Quicksand", sans-serif`,
                  fontWeight: 700,
                  fontSize: "24px",
                  lineHeight: "28.8px",
                  margin: "10px 10px 20px",
                  color: "#253D4E",
                }}
              >
                Links
              </Typography>
              <Box>
                {Pageslinks.map((link) => (
                  <Link
                    key={link.label}
                    href={link.href}
                    underline="none"
                    sx={linkStyle}
                  >
                    {link.label}
                  </Link>
                ))}
              </Box>
            </Grid>

            {/* Subscription Section */}
            <Grid item size={{ xs: 12, sm: 12, md: 3, lg: 3 }}>
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  fontFamily: `"Quicksand", sans-serif`,
                  fontWeight: 700,
                  fontSize: "24px",
                  lineHeight: "28.8px",
                  margin: "10px 10px 20px",
                  color: "#253D4E",
                }}
              >
                Contact Us
              </Typography>
              <Box>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    fontFamily: `"Lato", sans-serif`,
                    fontWeight: 400,
                    fontSize: "15px",
                    lineHeight: "24px",
                    marginBottom: "10px",
                    color: "#253D4E",
                    "& svg": {
                      fill: "#008BFF",
                    },
                  }}
                >
                  <CiLocationOn /> Address:  700 N. York Street
                  <br />
                  Dearborn, Michigan 48128 USA
                </Typography>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    fontFamily: `"Lato", sans-serif`,
                    fontWeight: 400,
                    fontSize: "15px",
                    lineHeight: "24px",
                    marginBottom: "10px",
                    color: "#253D4E",
                    "& svg": {
                      fill: "#008BFF",
                      stroke: "#008BFF",
                    },
                  }}
                >
                  <IoCallOutline /> Call Us: 313-353-1265
                </Typography>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    fontFamily: `"Lato", sans-serif`,
                    fontWeight: 400,
                    fontSize: "15px",
                    lineHeight: "24px",
                    marginBottom: "10px",
                    color: "#253D4E",
                    "& a": {
                      color: "#253D4E",
                      textDecoration: "none",
                    },
                    "& svg": {
                      stroke: "#008BFF",
                    },
                  }}
                >
                  <FiSend /> Email:
                  <a href="mailto:sale@lifeline.com">waleed@lifelinems.com</a>
                </Typography>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    fontFamily: `"Lato", sans-serif`,
                    fontWeight: 400,
                    fontSize: "15px",
                    lineHeight: "24px",
                    marginBottom: "10px",
                    color: "#253D4E",
                    "& svg": {
                      fill: "#008BFF",
                    },
                  }}
                >
                  <IoMdTime /> Hours: 10:00 - 18:00, Mon - Sat
                </Typography>
              </Box>
            </Grid>
          </Grid>

          {/* Footer Bottom */}
          <Box
            sx={{
              borderTop: "1px solid rgba(0, 139, 255, 0.33)",
              pt: 2,
              mt: 4,
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                fontFamily: `"Lato", sans-serif`,
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "24px",
                color: "#7E7E7E",
                "& a": {
                  color: "#008BFF",
                  textDecoration: "none",
                },
              }}
            >
              &copy; {new Date().getFullYear()},{" "}
              <a href="/">Lifeline Medical Supplies</a> All rights reserved
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "35px",
                  "& span a": {
                    fontSize: "26px",
                    lineHeight: "26px",
                    fontWeight: "700",
                    fontFamily: `'Quicksand', sans-serif`,
                    color: "#008BFF",
                    textDecoration: "none",
                  },
                  "& span span": {
                    fontSize: "12px",
                    lineHeight: "12px",
                    fontWeight: "500",
                    fontFamily: `'Lato', sans-serif`,
                    color: "#7E7E7E",
                    display: "block",
                  },
                  "& svg": {
                    color: "#7E7E7E",
                    fontSize: "30px",
                    marginRight: "10px",
                  },
                }}
              >
                <PiPhoneCallThin />
                <span>
                  <a href="tel:3133531265">313-353-1265</a>
                  <span>Working 8:00 - 22:00</span>
                </span>
              </Box>
              {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  "& span a": {
                    fontSize: "26px",
                    lineHeight: "26px",
                    fontWeight: "700",
                    fontFamily: `'Quicksand', sans-serif`,
                    color: "#008BFF",
                    textDecoration: "none",
                  },
                  "& span span": {
                    fontSize: "12px",
                    lineHeight: "12px",
                    fontWeight: "500",
                    fontFamily: `'Lato', sans-serif`,
                    color: "#7E7E7E",
                    display: "block",
                  },
                  "& svg": {
                    color: "#7E7E7E",
                    fontSize: "30px",
                    marginRight: "10px",
                  },
                }}
              >
                <PiPhoneCallThin />
                <span>
                  <a href="tel:3133531265">313-353-1265</a>
                  <span>24/7 Support Center</span>
                </span>
              </Box> */}
            </Box>
            {/* Social Media Icons */}
            <div>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  mt: 2,
                  gap: 1,
                }}
              >
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    fontFamily: `"Quicksand", sans-serif`,
                    fontWeight: 700,
                    fontSize: "16px",
                    lineHeight: "19.2px",
                    margin: "2px 10px 0px 0",
                    color: "#253D4E",
                  }}
                >
                  Follow Us
                </Typography>
                <Box component="ul" sx={{ listStyle: "none", display: "flex", gap: 2, padding: 0, margin: 0 }}>
                  {socialLinks.map((item, index) => (
                    <Box component="li" key={index}>
                      <a href={item.url} target="_blank" rel="noopener noreferrer" aria-label={item.label}>
                        <IconButton
                          sx={{
                            backgroundColor: "#008BFF",
                            border: "2px solid transparent",
                            borderRadius: "50%",
                            padding: "5px",
                            transition: "all 0.3s ease",
                            color: "white",
                            "&:hover": {
                              backgroundColor: "rgba(25, 118, 210, 0.04)",
                              borderColor: "#008BFF",
                              color: '#008BFF',
                            },
                          }}
                        >
                          {item.icon}
                        </IconButton>
                      </a>
                    </Box>
                  ))}
                </Box>
              </Box>
              <Typography
                sx={{
                  fontFamily: `"Lato", sans-serif`,
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "24px",
                  color: "#7E7E7E",
                }}
              >
                Up to 15% discount on your first subscribe
              </Typography>
            </div>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default AFooter;
